import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PlusCircle, Eye } from "react-feather";
import DataTable from "../../../../components/common/DataTable";
import StatusBadge from "../../components/StatusBadge";
import { useListStockAdjustmentsQuery } from "../../stockApi";
import { useCanCreateAdjustment } from "../../useStockPermissions";
import { useBranchFilter } from "../../../branchFilter/useBranchFilter";
import { paths } from "../../../../routes/paths";

const TYPE_OPTIONS = [
  { value: "", label: "All" },
  { value: "INCREASE", label: "Increase" },
  { value: "DECREASE", label: "Decrease" },
];

const StockAdjustmentList = () => {
  const canCreate = useCanCreateAdjustment();
  const navigate = useNavigate();
  const { selectedBranchId } = useBranchFilter();
  const [adjustmentType, setAdjustmentType] = useState("");
  const [includeDeleted, setIncludeDeleted] = useState(false);

  const { data, isLoading } = useListStockAdjustmentsQuery({
    branchId: selectedBranchId ?? undefined,
    adjustmentType: adjustmentType || undefined,
    includeDeleted,
    pageSize: 100,
  });

  const columns = [
    {
      title: "Adjustment No",
      dataIndex: "adjustmentNo",
      render: (value, record) => <Link to={paths.stockAdjustmentDetail(record.recordGuid)}>{value}</Link>,
    },
    { title: "Branch", dataIndex: "branchCode" },
    { title: "Type", dataIndex: "adjustmentType", render: (v) => (v === "INCREASE" ? "Increase" : "Decrease") },
    { title: "Reason", dataIndex: "reason" },
    { title: "Date", dataIndex: "adjustmentDate", render: (v) => (v ? new Date(v).toLocaleDateString() : "-") },
    { title: "Status", dataIndex: "status", render: (v) => <StatusBadge status={v} /> },
    {
      title: "Deleted",
      dataIndex: "isDeleted",
      render: (v) => (v ? <span className="badge badge-linedanger">Deleted</span> : "-"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <button type="button" className="btn btn-link p-2" title="View" onClick={() => navigate(paths.stockAdjustmentDetail(record.recordGuid))}>
          <Eye size={16} />
        </button>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock Adjustments</h4>
              <h6>Corrections to book stock with a required approval</h6>
            </div>
          </div>
          {canCreate && (
            <div className="page-btn">
              <button type="button" className="btn btn-added" onClick={() => navigate(paths.stockAdjustmentNew)}>
                <PlusCircle className="me-2" size={16} />
                New Adjustment
              </button>
            </div>
          )}
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top flex-wrap gap-2 justify-content-end">
              <select className="form-control" style={{ maxWidth: 200 }} value={adjustmentType} onChange={(e) => setAdjustmentType(e.target.value)}>
                {TYPE_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="adjustment-include-deleted"
                  checked={includeDeleted}
                  onChange={(e) => setIncludeDeleted(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="adjustment-include-deleted">Show deleted</label>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable columns={columns} dataSource={data?.items || []} rowKey="recordGuid" loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockAdjustmentList;
